import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'colorStringToHex',
    standalone: true
})
export class ColorStringToHexPipe implements PipeTransform {
    transform(value?: string): string {
        if (!value) {
            return '';
        }
        return value.indexOf('#') !== -1 ? value : `#${value}`;
    }
}
